/* lua.js generated code 0.3.0 */

require("clover/gameGuide/GameGuide")
require("clover/panel/base/panelShowHideAnim/PanelBounceAnim")
require("clover/panel/base/panelShowHideAnim/PanelScaleAnim")
var Event = require("cocos/framework/components/event")

BasePanel = xClass("BasePanel", Event)

BasePanelEvent = {
    Close: "BASEPANELEVENT.CLOSE"
}

BasePanel.prototype.ctor = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.init(...__VA_ARG)
}
BasePanel.prototype.init = function () {
    var self = this
    self.allowBackKeyTap = false
    self.nodeExist = true
    self.isClosed = false
    self.hasGridAd = false; // 关闭面板时是否需要清掉格子广告
    self.notHideBanner = false;
    self.notCheckBanner = false;
   
    // FIXME: event
    // self.enableNodeEvents()
    if (this instanceof cc.Node) {
        if (__DEBUG) {
            let isCleanupOverridden = (this.onCleanup !== cc.Node.prototype.onCleanup && this.onCleanup !== Event.prototype.onCleanup) || (this.cleanup !== cc.Node.prototype.cleanup && this.cleanup !== BasePanel.prototype.cleanup)
            if (!isCleanupOverridden) {
                // 此时还未加上class，拿不到name
                setTimeout(() => cc.warn(this.class && this.class.__cname, 'BasePanel.onCleanup is not overridden, please make sure to release all resource you have loaded'), 0)
            }
        }
        // let oldCleanup = this.cleanup
        // this.cleanup = () => {
        //     oldCleanup.call(this)
        //     this.onCleanup()
        // }
    }
    self.bind(self)
    self.fitIpad()
    //oppo平台的隐私协议面板弹出时，还没有require HomeScene
    if(window.HomeScene) {
        HomeScene.getInstance().hideBtns()
    }
    // self.setScale(Math.min(cc.winSize.height / GamePlayConfig_Design_Height, 1))
}

BasePanel.prototype.onViewChanged = function () {
    let self = this
    self.setPositionForPopoutManager()
    if (self._have_auto_fit) {
        self.fitResolution()
    }
}

BasePanel.resources = null
BasePanel.load = function (onSuccess, onFailure, onCancel, isShowTip = true) {
    return ResManager.loadWithTip(BasePanel.resources, onSuccess, onFailure, onCancel, isShowTip)
}
BasePanel.prototype.playMusicEffect = function () {
    //MusicPlayer:playEffect(GameMusicType.kBasePanelOpen)
}
// let homeScenePanelWhitelist = ["FriendPanel", "NewUserTaskPanel", "SevenDayLoginGetRewardPanel", "MarketPanel"]
let homeScenePanelWhitelist = [
    // 重写
    "FriendPanel",
    // 排除
    "GameRevivePanel", "LosePanel"
]
BasePanel.prototype.onEnter = function () {
    var self = this
    if (__DEBUG && self.class) {
        cc.log("BasePanel ",self.class.__cname)
    }
    if (self.close && self.close instanceof cc.Node) {
        cc.log("--------has close--------   will auto create back button in wechat");
    }
    if (isWechatGameEnv() && !self.changeCloseBtnPos && homeScenePanelWhitelist.indexOf(self.class.__cname) < 0) {
        // self.changeCloseBtnPos = true
        // FrameLoader.loadImageWithPlist("cocos/h5library.plist")
        // if (self.close && self.close instanceof cc.Node) {
        //     let tmpNode = null

        //     // contentSize 为空可以理解锚点为 0.5， 0,5
        //     if (self._contentSize.width === 0 || self._contentSize.height === 0) {
        //         self.close.setPositionX(-self.close.getPositionX())
        //     }else {
        //         self.close.setPositionX(cc.winSize.width - self.close.getPositionX())
        //     }
        //     // let worldPos = self.close.parent.convertToWorldSpace(self.close.getPosition())
        //     // let worldPos = cc.director._runningScene.convertToWorldSpace(self.close.getPosition())
        //     // let worldPos = self.convertToWorldSpace(self.close.getPosition())
        //     // let mirrorWorldPos = cc.p(cc.winSize.width - worldPos.x, worldPos.y)
        //     // self.close.setPosition(self.close.parent.convertToNodeSpace(mirrorWorldPos))
        //     self.close.setScale(1)
        //     self.close.pushBounceAnimInstance && self.close.pushBounceAnimInstance.updateScale()
        //     if (self.close instanceof cc.Sprite) {
        //         self.close.setSpriteFrame(cc.spriteFrameCache.getSpriteFrame("h5library/back_button.png"))
        //     }else if (self.close.children && self.close.children.length > 0) {
        //         tmpNode = self.close.getChildByName("click")
        //         if (tmpNode && tmpNode instanceof cc.Sprite) {
        //             tmpNode.setSpriteFrame(cc.spriteFrameCache.getSpriteFrame("h5library/back_button.png"))
        //         }
        //         tmpNode = self.close.getChildByName("normal")
        //         if (tmpNode && tmpNode instanceof cc.Sprite) {
        //             tmpNode.setSpriteFrame(cc.spriteFrameCache.getSpriteFrame("h5library/back_button.png"))
        //         }
        //         tmpNode = self.close.getChildByName("disabled")
        //         if (tmpNode && tmpNode instanceof cc.Sprite) {
        //             tmpNode.setSpriteFrame(cc.spriteFrameCache.getSpriteFrame("h5library/back_button.png"))
        //         }
        //     }
        
        // second way
        if (self.close && self.close instanceof cc.Node) {
            self.changeCloseBtnPos = true
            FrameLoader.loadImageWithPlist("cocos/h5library.plist")
            // let new_close = cc.Sprite.createWithSpriteFrameName("h5library/back_button.png");
            let new_close = cc.Sprite.createWithSpriteFrameName("h5library/back1.png");
            UIButton.create(new_close);
            PushBounceAnim.create(new_close);
            // new_close.setLocalZOrder(self.close.getLocalZOrder())
            // new_close.setAnchorPoint(self.close.getAnchorPoint())
            let newx = (0.5 - self.close._anchorPoint.x) * self.close._contentSize.width + self.close.getPositionX() - 5
            let newY = (0.5 - self.close._anchorPoint.y) * self.close._contentSize.height + self.close.getPositionY() - 5 
            if (self._contentSize.width === 0 || self._contentSize.height === 0) {
                newx = - newx
            }else {
                newx = cc.winSize.width - newx
            }
            new_close.setPosition(newx, newY)
            self.close.parent.addChild(new_close, self.close.getLocalZOrder())
            if (self.close.listeners_ && self.close.hasEventListener(UIButtonEvent.Click)) {
                new_close.listeners_ = self.close.listeners_
                new_close.nextListenerHandleIndex_ = self.close.nextListenerHandleIndex_
            }
            self.close.removeFromParent(true)
            self.close = new_close
        }
    }
    if (this instanceof cc.Node) {
        cc.Node.prototype.onEnter.call(this)
    }
    self.allowBackKeyTap = true
    //cc.log("BasePanel:onEnter()")
    
    self.playMusicEffect()
    GameGuide.getInstance().trigger(GameGuideTrigger.kPanelRise, table([1, "panel", self]))
}
//-默认会应用于所有面板，不需要自动适配的面板记得覆盖这个方法
BasePanel.prototype.fitResolution = function () {
    var self = this
    self._have_auto_fit = true //调用过这个方法的,可以考虑自适应
    var scale = Math.min(GamePlayConfig_RESOLUTION_SCALE, display.width / GamePlayConfig_Design_Width)
    self.setScale(scale)
}
/**
 * UI适配屏幕分辨率
 */
BasePanel.prototype.fitIpad = function () {
    var self = this
    if (isIpad()){
        var scaleY = display.height / GamePlayConfig_Design_Height
        var scaleX = display.width / GamePlayConfig_Design_Width
    
    
        var scale = Math.min(scaleX, scaleY)
        cc.log("fitIpad", scale)
        self._scale = scale
        self.setScale(self._scale)
    }else {
        self._scale = 1
    }

 

}
BasePanel.prototype.onExit = function () {
    var self = this
    //cc.log("BasePanel:onExit()")
    if (this instanceof cc.Node) {
        cc.Node.prototype.onExit.call(self)
    }
    cc.Director.getInstance().getOpenGLView().setIMEKeyboardState(false)
    GameGuide.getInstance().trigger(GameGuideTrigger.kPanelSink, table([1, "panel", self]))
}
// BasePanel.prototype.onEnterTransitionFinish = function () { }
// BasePanel.prototype.onExitTransitionStart = function () { }
BasePanel.prototype.cleanup = function () {
    let self = this
    this.removeAllEventListeners()
    if (!this.notHideBanner){
        SnsProxy.getInstance().hideBannerAd(true, self.adShowSession)
        SnsProxy.getInstance().hideGridAd();
    }
    if (this instanceof cc.Node) {
        cc.Node.prototype.cleanup.call(this)
    }
}

BasePanel.prototype.notHideBannerOnClose = function(){
    var self = this;
    self.notHideBanner = true;
}

BasePanel.prototype.notCheckBannerOnPopup = function(){
    var self = this;
    self.notCheckBanner = true;
}

BasePanel.prototype.onClose = function (callback, arg, withoutAnim) {
    var self = this
    if (self.isClosed) {
        return 
    }
    // MusicPlayer:playEffect(GameMusicType.kBasePanelClose)
    self.isClosed = true
    if (!self.notHideBanner){
        SnsProxy.getInstance().hideBannerAd(true, self.adShowSession)
        SnsProxy.getInstance().hideGridAd();
    }

    self.dispatchEvent({name: BasePanelEvent.Close, arg: arg});
    self.remove(true, callback, withoutAnim)
}

BasePanel.prototype.onClickPanel = function () { }
BasePanel.prototype.onClickAnywhere = function () { }
BasePanel.prototype.onClickEmpty = function () {
}
BasePanel.prototype.getChild = function (name) {
    var self = this
    return self.getChildByName(name)
}
BasePanel.prototype.onKeyBackClicked = function () {
    var self = this
    //cc.log("BasePanel:onKeyBackClicked !", self.allowBackKeyTap, self.isClosed)
    if (self.allowBackKeyTap) {
        if (!self.isClosed) {
            self.onClose()
        }
    }
}
BasePanel.prototype.becomeSecondPanel = function () { }
BasePanel.prototype.reBecomeTopPanel = function () { }
// withoutAnim == 1 适用于全屏界面进入
BasePanel.prototype.popup = function (dark, canTouchBehind, callback, withoutAnim, anchorCenter,maskOpacity) {
    var self = this
    //cc.log("BasePanel:popup()")
    if (!self.bannerAdOffsetY) {
        self.bannerAdOffsetY = 0;
    }
    PopoutManager.getInstance().addWithBgFadeIn(self, dark, canTouchBehind,null,null,null,maskOpacity)
    self.onEnterAnimStart()
    var vSize = cc.Director.getInstance().getVisibleSize()
    if (withoutAnim){
        if(withoutAnim == 1) {
            PanelBounceAnim.popup1(self, 0.3, cc.p(vSize.width / 2, vSize.height / 2 + self.bannerAdOffsetY), 0, function () {
                self.onEnterAnimFinish()
                if (callback) {
                    callback()
                }
            }, anchorCenter)
        }else {
            var size = self.getContentSize()
            self.setPosition((vSize.width - size.width) / 2, (vSize.height + size.height) / 2 + self.bannerAdOffsetY)
            self.onEnterAnimFinish()
            if (callback) {
                callback()
            }
        }
    }else{
        PanelBounceAnim.popup(self, 0.3, cc.p(vSize.width / 2, vSize.height / 2 + self.bannerAdOffsetY), 0, function () {
            self.onEnterAnimFinish()
            if (callback) {
                callback()
            }
        }, anchorCenter)
    }
    if (self.notCheckBanner){
        cc.log("popup not check banner")   
    }else{
        self.tryShowBannerAd()
    }
    return self
}
BasePanel.prototype.onEnterAnimStart = function () {
}
BasePanel.prototype.onEnterAnimFinish = function () { }
BasePanel.prototype.remove = function (cleanup, callback, withoutAnim) {
    var self = this
    //cc.log("BasePanel:remove()")
    self.onExitAnimStart()
    if (withoutAnim) {
        if(withoutAnim == 1) {
            PanelBounceAnim.remove1(self, callback);
            PopoutManager.getInstance().removeWithBgFadeOut(self, cleanup, null, 0);
        }else {
            if (callback != null && typeof callback == "function")
            callback();
        PopoutManager.getInstance().removeWithBgFadeOut(self, cleanup, null, 0);
        }
    } else {        
        var vSize = cc.Director.getInstance().getVisibleSize()        
        PopoutManager.getInstance().removeWithBgFadeOut(self, cleanup);
        PanelScaleAnim.remove(self, 0.2, cc.p(vSize.width / 2, vSize.height / 2 + self.bannerAdOffsetY), callback)
    }
}
BasePanel.prototype.onExitAnimStart = function () { }
BasePanel.prototype.center = function () {

    var wSize = cc.Director.getInstance().getWinSize()
    var self = this
    var s = self.getContentSize()
    var pos = self.getAnchorPoint()
    //cc.log("BasePanel center()")
    //cc.log(table.tostring(s))
    //cc.log(table.tostring(self.getBoundingBox()))
    printf("ap:%s", table.tostring(self.getAnchorPoint()))
    self.setPosition((wSize.width - s.width) * 0.5 + s.width * pos.x, (wSize.height + s.height) * 0.5 + s.height * pos.y)
    return self
}
BasePanel.prototype.safeCenter = function () {
    var wSize = cc.Director.getInstance().getWinSize()
    var self = this
    var s = self.getContentSize()
    var pos = self.getAnchorPoint()
    var scale = Math.abs(self.getScaleX())
    self.setPosition((wSize.width - s.width * scale) * 0.5 + s.width * scale * pos.x, (wSize.height + s.height * scale) * 0.5 + s.height * scale * pos.y)
    return self
}
BasePanel.prototype.createTouchButton = function (name, onTapped) {
    var self = this
    var btn = self.getChildByName(name)
    button(btn).onClicked(onTapped)
    return btn
}
BasePanel.prototype.setPositionForPopoutManager = function () {
    var self = this
    var vSize = cc.Director.getInstance().getVisibleSize()
    var wSize = cc.Director.getInstance().getWinSize()
    var vOrigin = cc.Director.getInstance().getVisibleOrigin()
    var posAdd = wSize.height - vSize.height - vOrigin.y
    cc.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
    cc.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
    cc.log("vSize:", vSize.width, vSize.height)
    cc.log("wSize:", wSize.width, wSize.height)
    cc.log("vOrigin:", vOrigin.x, vOrigin.y)
    cc.log("posAdd", posAdd)
    cc.log(display.center.x, -(vSize.height - display.center.y + posAdd))
    cc.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
    cc.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
    var size = self.getContentSize()
    self.setPosition(ccp(display.center.x - size.width / 2, vSize.height - display.center.y + posAdd + size.height / 2))
}
BasePanel.prototype.getReferenceScale = function () {
    var self = this
    var vSize = cc.Director.getInstance().getVisibleSize()
    var height = vSize.width * vSize.height / 720
    // WARN: maybe multi result
    return Math.min((700 + height) / 1980, 1)
}
/**
 * 尝试显示Banner广告
 */
BasePanel.prototype.tryShowBannerAd = function (onLoadCallback, onFailCallback, forceSkipGridAd = false) {
    cc.log("----------tryShowBannerAd-------------forceSkipGridAd", forceSkipGridAd);
    var self = this;
    //尝试隐藏当前已经有的banner广告
    SnsProxy.getInstance().hideBannerAd()
    SnsProxy.getInstance().hideGridAd()

    if (forceSkipGridAd == false){
        cc.log("#### gridAd: gridAdName "+self.gridAdName)
        if (self.gridAdName){
            // 失败格子广告， 概率为0，暂时废弃
            var gridAdConfig = MetaManager.getInstance().canShowGridAd(self.gridAdName);
            if (gridAdConfig){
                var snsProxy = require("clover/sns/SnsProxy").getInstance();
                snsProxy.showGridAd(gridAdConfig)
                .then(()=>{
                    DCAssist.userTrack("grid_ad", "show", {"type":self.gridAdName, "product_id":gridAdConfig.adUnitId});
                }, (err)=>{
                    console.log("#### gridAd: error "+ err)
                    snsProxy.destroyGridAd();
                    self.hasGridAd = false;
                    if (err && err.errMsg){
                        cc.log(err.errMsg)
                    }
                    cc.log("grid ad need version >= 2.11.1");
                    self.tryShowBannerAd(onLoadCallback, onFailCallback, true);
                });
                self.hasGridAd = true;
                return 2;
            }
        }
    }

    if (!self.hasGridAd){
        console.log("try show banner：" + self.bannerAdName);
        self.closeBanner = false;
        if (self.bannerAdName) {
            var metaManager = MetaManager.getInstance()
            console.log("check show Banner");
            self.bannerData = {};
            var bannerConfig = metaManager.canShowBannerAd(self.bannerAdName, self.bannerData);
            self.bannerData.interval = bannerConfig.adIntervals;
            if (bannerConfig) {
                console.log("this pannel can show Banner");
                self.isFirstShowBanner = true;
                self.bannerAd = SnsProxy.getInstance().loadBannerAd(
                    self.bannerAdName, 
                    self.bannerData,
                    metaManager.getAdUnit(self.bannerAdName),
                    (bannerAd) => {
                        //  如果在广告加载完毕的时候面板已经被关闭了，则不显示
                        console.warn("@@@@call loadbanner ad call back")
                        if (self.isClosed || self.closeBanner) {
                            console.warn("bannerPanel has close");
                            SnsProxy.getInstance().hideBannerAd();
                        } else {
                            //console.warn("show banner");
                            /*bannerAd.show().then(()=>{
                                if (self.isClosed || self.closeBanner) {
                                    bannerAd.hide();
                                } else {
                                    bannerAd.isShow = true;
                                }
                            });*/
                            
                            bannerAd.show()
                            // .then(()=>{
                            //     console.log("adids banner", bannerAd.adPos)
                            //     // if (!bannerAd.showed){
                            //     //     bannerAd.showed = true
                            //         console.log("dc4ads banner_ad")
                            //         self.adShowSession = DCAssist.dc4BannerAdShow(self.bannerAdName, metaManager.getAdUnit(self.bannerAdName));
                            //     // }
                            // });
                            bannerAd.isShow = true;
                            console.log("adids banner", bannerAd.adPos)
                            //  打点要求只有广告只有第一次显示的时候才打点，如果是自动刷新的则不打点
                            if (self.isFirstShowBanner) {
                                console.log("dc4ads banner_ad")
                                self.adShowSession = DCAssist.dc4BannerAdShow(self.bannerAdName, metaManager.getAdUnit(self.bannerAdName));
                                self.isFirstShowBanner = false;
                            }

                        }
                    }, 
                    onFailCallback);
                return 1;
            }
        }
    }
}
